import Tooltip from "../Tooltip";

function Label(props) {
	const { label, tooltip = false, required = false, className = false,marginClass = "mb-2" } = props;
	if (label) {
		return (
			<label htmlFor={label} className={`flex items-center font-Roboto font-bold text-sm text-black ${marginClass} ${className ? ` ${className}` : ''}`}>
				<span dangerouslySetInnerHTML={{ __html: label }} />
				{required === true && <span>*</span>}
				{tooltip !== false && <Tooltip label={tooltip} id={label} />}
			</label>
		)
	}
	return null
}

export default Label;
